<template>
  <div>
    <div style="position: absolute" class="main-back">
      <div class="main-back-filter"></div>
    </div>
    <div id="mainFrame" class="home-container">
      <div id="mainScreen" class="main-screen">
        <!-- 定位元素 -->
        <!-- 顶部背景 -->
        <div class="main-top-back">科研数据可视化平台</div>
        <!-- 大背景纹路 -->
        <div class="main-all-back"></div>
        <!-- 环绕光效 -->
        <div class="main-surround-effect-back"></div>
        <!-- 主背景 -->
        <div class="main-middle-back"></div>
        <!-- 生命科技、数智科技、绿色科技 -->
        <div class="main-base-content main-base-life-technologye">
          <div class="main-base-content-img">
            <div class="life-technologye-img"></div>
          </div>
          <div class="main-base-content-title">生命科技</div>
        </div>
        <div class="main-base-content main-base-shuzhi-technologye">
          <div class="main-base-content-img">
            <div class="shuzhi-technologye-img"></div>
          </div>
          <div class="main-base-content-title">数智科技</div>
        </div>
        <div class="main-base-content main-base-green-technologye">
          <div class="main-base-content-img">
            <div class="green-technologye-img"></div>
          </div>
          <div class="main-base-content-title">绿色科技</div>
        </div>
        <!-- 左上logo -->
        <div class="main-left-logo"></div>
        <!-- 右边时间 -->
        <div class="main-right-content">
          <div class="icon-item">
            <img
              src="@/assets/patent.png"
              alt=""
              class="patent-icon"
              @click="jumpToPatent"
            />
            <div style="text-align: center">知识产权</div>
          </div>
          <div class="icon-item">
            <img
              src="@/assets/AI@2x.png"
              alt=""
              class="AI-helper"
              @click="toggleShowAI"
            />
            <div style="text-align: center">招小科</div>
          </div>
          <local-time></local-time>
        </div>
        <!-- 中间研发基本信息 -->
        <div class="research-development-basic-info">
          <research-development-basic-info></research-development-basic-info>
        </div>
        <!-- 下面自动滚动项目 -->
        <div class="project-info-scroll">
          <project-info-scroll></project-info-scroll>
        </div>
        <!-- 知识产权概览 -->
        <div class="intellectual-property-content">
          <div class="common-title-back">知识产权概览</div>
          <div class="intellectual-property-info common-content-back">
            <intellectual-property></intellectual-property>
          </div>
        </div>
        <!-- AI算力监控 -->
        <div class="AI-computing-power-monitoring-content">
          <div class="common-title-back">AI算力监控</div>
          <div class="AI-computing-power-monitoring-chart common-content-back">
            <ai-computing-power-monitoring-chart></ai-computing-power-monitoring-chart>
          </div>
        </div>
        <!-- 领域覆盖 -->
        <div class="domain-coverage-content">
          <div class="common-title-back">领域覆盖</div>
          <div class="domain-coverage-info common-content-back">
            <domain-coverage></domain-coverage>
          </div>
        </div>
        <!-- 项目进度 -->
        <div class="project-schedule-content">
          <div class="common-title-back">项目状态</div>
          <div class="project-schedule-chart common-content-back">
            <project-schedule-chart></project-schedule-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocalTime from "@/components/local-time.vue";
import ResearchDevelopmentBasicInfo from "@/components/research-development-basic-info.vue";
import ProjectInfoScroll from "@/components/project-info-scroll.vue";
import IntellectualProperty from "@/components/intellectual-property.vue";
import ProjectScheduleChart from "@/components/project-schedule-chart.vue";
import DomainCoverage from "@/components/domain-coverage.vue";
import AiComputingPowerMonitoringChart from "@/components/ai-computing-power-monitoring-chart.vue";
export default {
  name: "Home",
  components: {
    LocalTime,
    ResearchDevelopmentBasicInfo,
    ProjectInfoScroll,
    IntellectualProperty,
    ProjectScheduleChart,
    DomainCoverage,
    AiComputingPowerMonitoringChart
  },
  data() {
    return {};
  },
  computed: {
    jumpUrl() {
      return this.$store.state.aiChat.jumpUrl + this.$store.state.aiChat.token;
    },
  },
  methods: {
    jumpToPatent() {
      this.$router.push({
        path: "/intellectual-property-knowledge-full",
      });
    },
    toggleShowAI() {
      this.$parent.toggleShowAI();
    },
  },
};
</script>

<style lang="less" scoped>
#mainScreen {
  // background-color: #ff8800;
  // border: 3px solid #00ff00;
  box-sizing: border-box;
  position: relative;
}
@media screen and (max-aspect-ratio: 16/9) {
  #mainScreen {
    width: 100vw;
    height: calc(100vw * 9 / 16);
  }
}
@media screen and (min-aspect-ratio: 16/9) {
  #mainScreen {
    width: calc(100vh * 16 / 9);
    height: 100vh;
  }
}
.main-back {
  width: 100vw;
  height: 100vh;
  background: url(/src/assets/imgs/maniFrame.png) center center / 100% 100%
    no-repeat;
  .main-back-filter {
    height: 100%;
    backdrop-filter: blur(20px);
  }
}
#mainFrame {
  position: relative;
  z-index: 100;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-screen {
  background: url(/src/assets/imgs/maniFrame.png) center center / contain
    no-repeat;
  .main-top-back {
    position: absolute;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 10%;
    background: url(/src/assets/imgs/mainTopBack.png) center center / 100% 100%
      no-repeat;
    color: #fff;
    font-size: 2rem;
  }
  .main-all-back {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
    background: url(/src/assets/imgs/mainAllBack.png) center center / 100% 100%
      no-repeat;
  }
  .main-surround-effect-back {
    position: absolute;
    left: 25%;
    top: 25%;
    width: 50%;
    height: 50%;
    background: url(/src/assets/imgs/mainSurroundEffectBack.gif) center center /
      100% 100% no-repeat;
    opacity: 0.5;
  }
  .main-base-life-technologye {
    position: absolute;
    z-index: 3;
    top: 49%;
    left: 33%;
    color: #fff;
  }
  .main-base-shuzhi-technologye {
    position: absolute;
    z-index: 3;
    top: 54%;
    left: 46%;
    color: #fff;
  }
  .main-base-green-technologye {
    position: absolute;
    z-index: 3;
    top: 49%;
    left: 59%;
    color: #fff;
  }
  .main-base-content {
    width: 8%;
    height: 21%;
    z-index: 1;
    .main-base-content-img {
      opacity: 0.8;
      width: 100%;
      height: 84%;
      background: url(/src/assets/imgs/baseSeat.png) center center / contain
        no-repeat;
      // background: red;
      .life-technologye-img {
        background: url(/src/assets/imgs/seatBack1.png) center center / contain
          no-repeat;
        width: 53%;
        height: 84%;
        margin-left: 32%;
      }
      .shuzhi-technologye-img {
        background: url(/src/assets/imgs/seatBack2.png) center center / contain
          no-repeat;
        width: 53%;
        height: 86%;
        margin-left: 24%;
      }
      .green-technologye-img {
        background: url(/src/assets/imgs/seatBack3.png) center center / contain
          no-repeat;
        width: 53%;
        height: 83%;
        margin-left: 23%;
      }
    }
    .main-base-content-title {
      width: 100%;
      height: 16%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.5rem;
      position: relative;
      top: -7%;
    }
  }
  .main-middle-back {
    position: absolute;
    left: 13%;
    top: -11%;
    z-index: 3;
    height: 100%;
    width: 77%;
    background: url(/src/assets/imgs/mainMiddleBack.png) center center / contain
      no-repeat;
    opacity: 0.8;
  }
  .main-left-logo {
    position: absolute;
    z-index: 3;
    left: 2.5%;
    top: 6.5%;
    width: 14%;
    height: 5%;
    background: url(/src/assets/imgs/logo.png) center center / contain no-repeat;
  }
  .main-right-content {
    position: absolute;
    z-index: 3;
    right: 2.5%;
    top: 6.5%;
    width: 18%;
    height: 5%;
    display: flex;
    justify-content: flex-end;
    .icon-item {
      height: 100%;
      width: 20%;
      margin: 0 8px;
      color: #fff;
      font-size: 0.8rem;
      .patent-icon {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      .AI-helper {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .research-development-basic-info {
    position: absolute;
    z-index: 3;
    left: 28%;
    top: 19%;
    width: 45%;
    color: #fff;
  }
  .project-info-scroll {
    position: absolute;
    z-index: 5;
    top: 77%;
    left: 27%;
    width: 46%;
    height: 17%;
    overflow: hidden;
  }
  .intellectual-property-content {
    position: absolute;
    z-index: 5;
    top: 13%;
    left: 3%;
    width: 23%;
    height: 40%;
    .intellectual-property-info {
      height: 87.5%;
      padding: 6px 0;
    }
  }
  .domain-coverage-content {
    position: absolute;
    z-index: 5;
    top: 15%;
    right: 3%;
    width: 23%;
    height: 38%;
    .domain-coverage-info {
      height: 81.5%;
      padding-top: 6%;
    }
  }
  .AI-computing-power-monitoring-content {
    position: absolute;
    z-index: 5;
    top: 57%;
    left: 3%;
    width: 23%;
    height: 37%;
    .AI-computing-power-monitoring-chart {
      height: 85.5%;
      padding: 2% 2% 0 2%;
    }
  }
  .project-schedule-content {
    position: absolute;
    z-index: 5;
    top: 56%;
    right: 3%;
    width: 23%;
    height: 38%;
    .project-schedule-chart {
      height: 81.5%;
      padding-top: 6%;
    }
  }
  .common-title-back {
    height: 12.5%;
    color: #fff;
    padding-left: 9%;
    display: flex;
    align-items: center;
    background: url(/src/assets/imgs/commonTitleBack1.png) center center /
      contain no-repeat;
  }
  .common-content-back {
    background: url(/src/assets/imgs/commonContentBack.png) center center /
      contain no-repeat;
  }
}
</style>
